import { Box, Button, Chip, Modal, styled, Typography, TextField, Stack, IconButton } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import theme from "../../styles/theme";
import { useState } from "react";
import SearchDialogUp from "../appDialog/searchUp";

const GlassModal = styled(Modal)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const ContentBox = styled(Box)(() => ({
  position: "relative", // ⭐ 让右上角按钮可以定位
  backdropFilter: "blur(20px)",
  background: "rgba(255, 255, 255, 0.75)",
  borderRadius: "20px",
  boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
  padding: "24px 20px",
  width: 320,
  maxHeight: "85vh",
  overflowY: "auto",
}));

const SectionTitle = styled(Typography)(() => ({
  fontSize: 13,
  fontWeight: 500,
  color: "rgba(0,0,0,0.6)",
  margin: "16px 0 8px",
}));

const StyledTextField = styled(TextField)(() => ({
  "& .MuiInputBase-root": {
    borderRadius: "12px",
    background: "rgba(255,255,255,0.9)",
    padding: "4px 10px",
  },
  "& .MuiInputBase-input": {
    fontSize: 14,
  },
}));

const StyledChip = styled(Chip)(() => ({
  margin: "0 8px 8px 0",
  borderRadius: "16px",
  fontSize: 13,
  background: "rgba(240,240,240,0.8)",
  transition: "all 0.2s ease",
  "&:hover": {
    background: "rgba(230,230,230,1)",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
  },
}));

export default function MobileSearchModal({ openSearch, setOpenSearch }) {
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const [openSearch2, setOpenSearch2] = useState(false);
  const [chipTitle, setChipTitle] = useState(null);
  const [value, setValue] = useState("");

  const handleClose = () => setOpenSearch(false);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleOpenSearch = (keyword) => {
    const msg = keyword || value;
    if (msg === "") {
      setOpenSearch(false);
      return;
    }
    setChipTitle(msg);
    setOpenSearch2(true);
  };

  return (
    <Box>
      <SearchDialogUp
        openSearch={openSearch2}
        setOpenSearch={setOpenSearch2}
        matches={matches}
        chipTitle={chipTitle}
      />
      <GlassModal open={openSearch} onClose={handleClose}>
        <ContentBox>
          {/* 右上角关闭按钮 */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              color: "rgba(0,0,0,0.6)",
              "&:hover": { color: "rgba(0,0,0,0.9)" },
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            variant="h6"
            textAlign="center"
            fontSize={16}
            fontWeight={500}
            mb={2}
            sx={{
              background: "linear-gradient(90deg, #7b61ff, #5ac8fa)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            搜索
          </Typography>

          <StyledTextField
            variant="outlined"
            placeholder="搜索博主或视频类型"
            onChange={handleChange}
            type="search"
            fullWidth
          />

          <Stack spacing={2} direction="row" mt={2}>
            <Button
              onClick={() => {
                handleOpenSearch();
              }}
              fullWidth
              sx={{
                borderRadius: "12px",
                textTransform: "none",
                fontSize: 14,
                background: "linear-gradient(90deg, #7b61ff, #5ac8fa)",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                "&:hover": {
                  background: "linear-gradient(90deg, #6a4fff, #4bb7e8)",
                },
              }}
              variant="contained"
            >
              搜索
            </Button>
          </Stack>

          <SectionTitle>平台种类</SectionTitle>
          <Box mt={1}>
            {["推特", "onlyfans", "fansone", "umate", "海角", "夜未央夫妻"].map((label) => (
              <StyledChip key={label} label={label} onClick={() => handleOpenSearch(label)} size="small" />
            ))}
          </Box>

          <SectionTitle>视频种类</SectionTitle>
          <Box mt={1}>
            {["绿帽", "换妻", "乱伦", "3P", "群P", "媚黑", "内射", "双龙入洞", "灌精", "露出", "调教", "颜值", "偷拍", "SM", "熟女", "少妇"].map(
              (label) => (
                <StyledChip key={label} label={label} onClick={() => handleOpenSearch(label)} size="small" />
              )
            )}
          </Box>
        </ContentBox>
      </GlassModal>
    </Box>
  );
}
